/* Anonymous comparison selection. Product truth is read from Shopify on every open. */
(() => {
  'use strict';
  const KEY = 'dyravinir:compare:v1';
  const LEGACY = 'dyravinir:ux160:compare';
  const LIMIT = 3;
  const labels = {"species": {"hundur": "Hundur", "kottur": "Köttur", "hundur_kottur": "Hundar og kettir"}, "protein": {"kjuklingur": "Kjúklingur", "kalkunn": "Kalkúnn", "ond": "Önd", "lamb": "Lambakjöt", "naut": "Nautakjöt", "hross": "Hrossakjöt", "visundur": "Vísundakjöt", "dadyr": "Dádýr", "villisvin": "Villisvín", "kanina": "Kanína", "lax": "Lax", "silungur": "Silungur", "hvitfiskur": "Hvítfiskur", "sild": "Síld", "skordyraprotein": "Skordýraprótein", "egg": "Egg"}, "age": {"hvolpur": "Hvolpur", "kettlingur": "Kettlingur", "fullordinn": "Fullorðinn", "eldri": "Eldri", "ollum_aldri": "Hæft öllum aldri", "medganga_mjolkurgjof": "Meðganga og mjólkurgjöf", "fullorðinn": "Fullorðinn", "allur aldur": "Hæft öllum aldri", "hvolpafull / nýleg gota": "Meðganga og mjólkurgjöf"}, "form": {"thurrfodur": "Þurrfóður", "blautfodur": "Blautfóður", "nammi": "Nammi og snakk", "faedubot": "Fæðubót", "topper": "Áleggsfóður", "frostthurrkad": "Frostþurrkað", "dry": "Þurrfóður", "wet": "Blautfóður", "treats": "Nammi og snakk", "supplement": "Fæðubót", "freeze dried": "Frostþurrkað", "freeze-dried": "Frostþurrkað"}};
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,200}$/.test(value);
  const normalize = values => Array.isArray(values) ? [...new Set(values.filter(validHandle))].slice(0, LIMIT) : [];
  let selected = [];
  let saved = true;
  try {
    const stored = localStorage.getItem(KEY);
    if (stored !== null) selected = normalize(JSON.parse(stored));
    else {
      const old = JSON.parse(localStorage.getItem(LEGACY) || '[]');
      selected = normalize(Array.isArray(old) ? old.map(item => /^\/products\/([a-z0-9-]+)$/.exec(item?.url || '')?.[1]) : []);
      localStorage.setItem(KEY, JSON.stringify(selected));
    }
  } catch { saved = false; }
  const data = new Map();
  const pending = new Set();
  const failures = new Set();
  let generation = 0;
  let limitMessage = false;
  let returnFocus;
  let dock, dialog, content, notice, announcer, difference, basis;
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const button = (text, action) => {
    const node = el('button', '', text);
    node.type = 'button'; node.addEventListener('click', action); return node;
  };
  const say = message => { announcer.textContent = message; };
  const save = () => {
    try { localStorage.setItem(KEY, JSON.stringify(selected)); saved = true; }
    catch { saved = false; say('Valið helst á þessari síðu en ekki tókst að vista það í vafranum.'); }
  };
  function sync() {
    document.querySelectorAll('.dv-compare-button').forEach(control => {
      const active = selected.includes(control.dataset.handle);
      const label = active ? 'Valið til samanburðar' : 'Bera saman';
      if (control.textContent !== label) control.textContent = label;
      if (control.getAttribute('aria-pressed') !== String(active)) control.setAttribute('aria-pressed', String(active));
    });
    dock.hidden = selected.length === 0;
    const count = `${selected.length} ${selected.length === 1 ? 'vara valin' : 'vörur valdar'}`;
    dock.querySelector('strong').textContent = count;
    dock.querySelector('small').textContent = saved ? 'Valið geymist í þessum vafra' : 'Valið geymist aðeins á þessari síðu';
    dock.querySelector('button').textContent = `Skoða samanburð (${selected.length})`;
  }
  function remove(handle) {
    limitMessage = false;
    selected = selected.filter(item => item !== handle);
    save(); sync(); render();
    // The removed column no longer exists. Keep keyboard focus inside the dialog.
    if (dialog.open) dialog.querySelector('[data-close]').focus();
    say('Vara fjarlægð úr samanburði.');
  }
  function addControls(root = document) {
    root.querySelectorAll('.product-card-wrapper[data-product-handle]').forEach(card => {
      if (!['Hundafóður', 'Kattafóður'].includes(card.dataset.productType)) return;
      const handle = card.dataset.productHandle;
      if (!validHandle(handle) || card.querySelector('.dv-compare-button')) return;
      const control = button('Bera saman', () => {
        if (selected.includes(handle)) return remove(handle);
        if (selected.length === LIMIT) {
          limitMessage = true;
          open(); say('Þrjár vörur eru þegar valdar. Fjarlægðu eina til að bæta annarri við.');
          notice.textContent = 'Þrjár vörur eru þegar valdar. Fjarlægðu eina til að bæta annarri við.';
          return;
        }
        selected.push(handle); save(); sync(); say('Vara valin. Opnaðu Skoða samanburð til að sjá yfirlitið.');
      });
      control.className = 'dv-compare-button'; control.dataset.handle = handle;
      control.setAttribute('aria-label', `Bera saman: ${card.dataset.productTitle || handle}`);
      control.setAttribute('aria-pressed', 'false');
      (card.querySelector('.quick-add') || card.querySelector('.card__content:last-child') || card).append(control);
    });
    sync();
  }
  const number = value => typeof value === 'number' && Number.isFinite(value) ? value : null;
  // Some embedded Chromium builds lack Icelandic ICU data. Keep storefront notation stable.
  const format = (value, precision = 1) => {
    const [whole, fraction = ''] = value.toFixed(precision).split('.');
    const decimal = fraction.replace(/0+$/, '');
    return whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (decimal ? `,${decimal}` : '');
  };
  const money = (value, currency) => `${format(value / 100, currency === 'ISK' ? 0 : 2)} ${currency === 'ISK' ? 'kr.' : currency}`;
  const missing = 'Ekki skráð';
  const values = value => Array.isArray(value) ? value : value == null || value === '' ? [] : [value];
  const label = (value, vocabulary) => values(value).map(item => vocabulary?.[item] || vocabulary?.[String(item).toLowerCase()] || String(item)).join(', ') || missing;
  function nutrient(product, key) {
    const value = number(product.nutrition?.[key]);
    if (value === null || value < 0 || value > 100) return missing;
    if (basis.value === 'dm' && key !== 'moisture') {
      const moisture = number(product.nutrition?.moisture);
      if (moisture === null || moisture < 0 || moisture >= 100) return 'Vantar rakagildi';
      if (value + moisture > 100) return 'Ósamræmi í skráningu';
      return `${format(value * 100 / (100 - moisture))}%`;
    }
    return `${format(value)}%`;
  }
  const path = handle => `${window.Shopify?.routes?.root || '/'}products/${handle}`;
  async function refresh() {
    const run = ++generation;
    data.clear(); failures.clear(); pending.clear();
    const handles = [...selected];
    handles.forEach(handle => pending.add(handle));
    render();
    await Promise.all(handles.map(async handle => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        const url = new URL(path(handle), location.origin);
        url.searchParams.set('view', 'dv-compare');
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { credentials:'same-origin', cache:'no-store', signal:controller.signal });
        if (!response.ok) throw new Error('Product unavailable');
        const product = JSON.parse(await response.text());
        if (product.version !== 1 || product.handle !== handle || product.eligible !== true ||
            typeof product.title !== 'string' || !/^\d+$/.test(product.id) ||
            !/^\d+$/.test(product.variant?.id) || !/^[A-Z]{3}$/.test(product.currency)) throw new Error('Invalid comparison data');
        if (run === generation && selected.includes(handle)) data.set(handle, product);
      } catch { if (run === generation && selected.includes(handle)) failures.add(handle); }
      finally {
        clearTimeout(timer);
        if (run === generation) pending.delete(handle);
      }
    }));
    if (run === generation) {
      // Commit once: a slower response must not destroy controls the user is using.
      render();
      say(failures.size ? 'Ekki tókst að sækja allar vörur. Reyndu aftur eða fjarlægðu vöruna.' : 'Samanburður tilbúinn.');
    }
  }
  function render() {
    if (!dialog.open) return;
    content.replaceChildren();
    if (!selected.length) {
      content.append(el('p', 'dv-compare-empty', 'Engar vörur valdar. Lokaðu samanburðinum og veldu Bera saman á vörum sem þú vilt skoða.'));
      notice.textContent = ''; return;
    }
    const products = selected.map(handle => data.get(handle));
    const table = el('table', 'dv-compare-table');
    table.style.setProperty('--dv-compare-count', selected.length);
    table.setAttribute('aria-label', 'Vörur og eiginleikar hlið við hlið');
    const head = table.createTHead().insertRow();
    const corner = el('th', 'dv-compare-label', 'Veldu fóðrið sem hentar'); corner.scope = 'col'; head.append(corner);
    selected.forEach((handle, index) => {
      const product = products[index];
      const th = el('th'); th.scope = 'col';
      if (product) {
        // No merchant content is inserted as HTML; image hosts are restricted to Shopify.
        try {
          const source = new URL(product.image, location.origin);
          if (product.image && source.protocol === 'https:' && (source.origin === location.origin || source.hostname === 'cdn.shopify.com')) {
            const img = el('img'); img.src = source.href; img.alt = ''; img.width = 88; img.height = 100; th.append(img);
          }
        } catch { /* Missing media is optional. */ }
        th.append(el('small', '', product.vendor), el('h3', '', product.title));
      } else th.append(el('h3', '', pending.has(handle) ? 'Sæki vöru…' : 'Ekki tókst að sækja vöru'));
      const removeButton = button('Fjarlægja', () => remove(handle));
      removeButton.setAttribute('aria-label', `Fjarlægja ${product?.title || handle}`);
      th.append(removeButton);
      if (failures.has(handle)) th.append(button('Reyna aftur', refresh));
      head.append(th);
    });
    const compact = table.tHead.insertRow(); compact.className = 'dv-compare-compact';
    const compactLabel = el('th', 'dv-compare-label', 'Vara'); compactLabel.scope = 'col'; compact.append(compactLabel);
    products.forEach(product => {
      const th = el('th'); th.scope = 'col';
      const name = el('span', '', product?.title || 'Sæki vöru…'); name.title = name.textContent;
      th.append(name); compact.append(th);
    });
    const body = table.createTBody();
    function group(title) {
      const row = body.insertRow(); row.className = 'dv-compare-group';
      const heading = el('th', '', title); heading.colSpan = selected.length + 1; row.append(heading);
    }
    function row(title, getter) {
      const cells = products.map(p => p ? getter(p) : '—');
      const differs = new Set(cells).size > 1;
      if (difference.checked && !differs) return;
      const tr = body.insertRow(); if (differs) tr.className = 'dv-compare-different';
      const th = el('th', 'dv-compare-label', title); th.scope = 'row'; tr.append(th);
      cells.forEach(value => tr.append(el('td', '', value)));
    }
    group('Verð og eiginleikar');
    row('Verð', p => number(p.variant.price) !== null && p.variant.price >= 0 ? money(p.variant.price, p.currency) : missing);
    row('Verð á kg', p => number(p.variant.grams) > 0 && number(p.variant.price) !== null && p.variant.price >= 0 ? `${money(p.variant.price * 1000 / p.variant.grams, p.currency)} / kg` : missing);
    row('Pakkning', p => number(p.variant.grams) > 0 ? p.variant.grams < 1000 ? `${format(p.variant.grams)} g` : `${format(p.variant.grams / 1000, 3)} kg` : missing);
    if (products.some(p => p && p.variant.title !== 'Default Title')) {
      row('Afbrigði', p => p.variant.title === 'Default Title' ? 'Hefðbundin pakkning' : p.variant.title || missing);
    }
    row('Framboð', p => p.variant.available === true ? 'Hægt að panta' : p.variant.available === false ? 'Ekki í boði' : missing);
    row('Dýr', p => label(p.species, labels.species));
    row('Tegund fóðurs', p => label(p.form, labels.form));
    row('Aldur', p => label(p.age, labels.age));
    row('Aðalpróteingjafi', p => label(p.protein, labels.protein));
    group(basis.value === 'dm' ? 'Næring — reiknað á þurrefnisgrunni' : 'Næring — í fóðrinu eins og það er gefið');
    [['Prótein','protein'],['Fita','fat'],['Trefjar','fibre'],['Aska','ash'],['Raki (í fóðrinu)','moisture']].forEach(([name,key]) => row(name, p => nutrient(p,key)));
    row('Orka', p => number(p.nutrition?.energy) > 0 ? `${format(p.nutrition.energy)} kcal/kg` : missing);
    // Ingredients are always available; the difference filter never hides the disclosure controls.
    group('Innihald og nánari upplýsingar');
    const ingredients = body.insertRow();
    const th = el('th', 'dv-compare-label', 'Innihald'); th.scope = 'row'; ingredients.append(th);
    products.forEach((p, index) => {
      const td = el('td');
      if (p?.ingredients) {
        const details = el('details'); details.append(el('summary', '', 'Sjá allt innihald'), el('p', '', p.ingredients)); td.append(details);
      } else td.append(el('p', '', p ? missing : '—'));
      const link = el('a', 'dv-compare-product-link', 'Skoða vöru');
      link.href = `${path(selected[index])}${p ? `?variant=${p.variant.id}` : ''}`; td.append(link); ingredients.append(td);
    });
    content.append(table);
    const forms = new Set(products.filter(Boolean).map(p => label(p.form, labels.form)));
    const mixed = forms.has('Þurrfóður') && forms.has('Blautfóður');
    const species = new Set(products.filter(Boolean).flatMap(p => values(p.species))).size > 1;
    notice.textContent = [limitMessage ? 'Þrjár vörur eru þegar valdar. Fjarlægðu eina til að bæta annarri við.' : '',
      species ? 'Valið inniheldur fóður fyrir ólík dýr.' : '',
      mixed && basis.value !== 'dm' ? 'Þurrfóður og blautfóður hafa ólíkt rakainnihald. Veldu þurrefnisgrunn fyrir samanburð á næringarhlutföllum.' : '',
      basis.value === 'dm' ? 'Þurrefni er reiknað úr skráðum rakagildum. Orka og verð miðast áfram við fóðrið eins og það er selt.' : '',
      'Ekki skráð merkir að upplýsingar vanti. Verð er fyrir staka pakkningu, fyrir möguleg körfutilboð.'].filter(Boolean).join(' ');
  }
  function open() {
    if (!dialog.open) { returnFocus = document.activeElement; dialog.showModal(); dialog.querySelector('[data-close]').focus(); }
    refresh();
  }
  function start() {
    announcer = el('div', 'dv-compare-live'); announcer.setAttribute('role','status'); announcer.setAttribute('aria-live','polite'); document.body.append(announcer);
    dock = el('aside', 'dv-compare-dock'); dock.setAttribute('aria-label','Valdar samanburðarvörur');
    const summary = el('p'); summary.append(el('strong'), el('small')); dock.append(summary, button('Skoða samanburð',open));
    dialog = el('dialog', 'dv-compare-dialog'); dialog.setAttribute('aria-labelledby','dv-compare-title');
    const toolbar = el('header','dv-compare-toolbar');
    const title = el('div'); const h = el('h2','','Bera saman fóður'); h.id = 'dv-compare-title';
    title.append(h,el('p','','Allt að þrjár vörur, hlið við hlið.'));
    const close = button('Loka',() => dialog.close()); close.dataset.close = ''; toolbar.append(title,close);
    const options = el('div','dv-compare-options');
    const diffLabel = el('label'); difference = el('input'); difference.type = 'checkbox'; diffLabel.append(difference,document.createTextNode('Bara mismunur')); difference.addEventListener('change',render);
    const basisLabel = el('label','','Næringargrunnur'); basis = el('select');
    [['fed','Eins og gefið'],['dm','Þurrefnisgrunnur']].forEach(([value,text]) => { const option = el('option','',text); option.value = value; basis.append(option); });
    basisLabel.append(basis); basis.addEventListener('change',render);
    options.append(diffLabel,basisLabel,button('Hreinsa val',() => { selected=[]; save(); sync(); render(); close.focus(); }));
    content = el('div','dv-compare-scroll'); content.tabIndex = 0; content.setAttribute('aria-label','Samanburðartafla. Skrunaðu til hliðar til að sjá allar vörur.');
    notice = el('p','dv-compare-notice');
    dialog.append(toolbar,options,content,notice); document.body.append(dock,dialog);
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),summary,[tabindex="0"]')]
        .filter(node => node.getClientRects().length > 0);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    dialog.addEventListener('close',() => { ++generation; if (returnFocus?.isConnected && !returnFocus.closest('[hidden]')) returnFocus.focus(); });
    addControls();
    document.addEventListener('shopify:section:load',event => addControls(event.target));
    const main = document.querySelector('#MainContent');
    if (main) {
      let scheduled = false;
      new MutationObserver(records => {
        if (scheduled || !records.some(record => record.addedNodes.length)) return;
        scheduled = true; requestAnimationFrame(() => { scheduled = false; addControls(main); });
      }).observe(main,{childList:true,subtree:true});
    }
    window.addEventListener('storage',event => {
      if (event.key !== KEY) return;
      try { selected = normalize(JSON.parse(event.newValue || '[]')); sync(); if (dialog.open) refresh(); } catch { /* Ignore malformed external storage. */ }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
